import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiCallWithRetry, client } from '../../../client';

export const fetchTableSettings = createAsyncThunk(
  'table/fetchSettings',
  async (patch, { rejectWithValue }) => {
    const apiCall = async () => {
      return await client.get('/user/preferences');
    };

    try {
      const response = await apiCallWithRetry(apiCall, 3, 1000);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const sendNewTableSettings = createAsyncThunk(
  'table/pastSettings',
  async ({ path, patch }, { rejectWithValue }) => {
   if (patch.length) {
     const apiCall = async () => {
       return await client.patch('/user/preferences/' + path, patch);
     };

     try {
       const response = await apiCallWithRetry(apiCall, 3, 1000);
       return response;
     } catch (error) {
       return rejectWithValue(error.response?.data || error.message);
     }
   }
  },
);
